import React from "react";
import style from "./index.module.scss";
import { ColumnProps } from "antd/lib/table/interface";
import { Table } from "antd";
import {
    LearnDataProps,
    StudyStatusEntity
} from "../../../../../service/CourseDetail/resource";
import Style from "./index.module.scss";
import { Can } from "../../../../../service/service";
import moment from "moment";
import Statics from "../Statics";
import Search from "../Search";

interface VoteStuTableProp {
    data: LearnDataProps | null;
    filterStatus: string;
    setFilterStatus: (str: string) => void;
    searchText: string;
    setSearchText: (str: string) => void;
}

export default function VoteStuTable({
    data,
    filterStatus,
    setFilterStatus,
    searchText,
    setSearchText
}: VoteStuTableProp) {
    const columns: ColumnProps<StudyStatusEntity>[] = [
        {
            title: "序号",
            render: (text, item, index) => index + 1,
            align: "center",
            key: "index"
        },
        {
            title: "班级",
            dataIndex: "studentMarkModel.className"
        },
        {
            title: "学生信息",
            dataIndex: "className",
            render: (text, item) => {
                return (
                    <div className={Style.stuContent}>
                        <p>{item?.studentMarkModel?.name}</p>
                        <p>{item?.studentMarkModel?.studentNo}</p>
                    </div>
                );
            }
        },
        {
            title: "下载次数",
            dataIndex: "downloadCount"
        },
        {
            title: "学习状态",
            dataIndex: "studyStatus",
            render: text => {
                return <span>{text === Can.yes ? "是" : "否"}</span>;
            }
        },
        {
            title: "学习时间",
            dataIndex: "studyTime",
            render: text => {
                return (
                    <span>
                        {text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""}
                    </span>
                );
            }
        }
    ];

    return (
        <div className={style.root}>
            <div className={style.header}>
                <Statics
                    current={filterStatus}
                    onChange={setFilterStatus}
                    courseStuCount={
                        data?.dcCoursewareSourceStatics?.totalNumber || 0
                    }
                    doneNumber={
                        data?.dcCoursewareSourceStatics?.hasLearnNumber || 0
                    }
                    unDoneNumber={
                        data?.dcCoursewareSourceStatics?.notLearnNumber || 0
                    }
                />
                <Search onChange={setSearchText} className={style.search} />
            </div>

            <div className={style.table}>
                <Table
                    columns={columns}
                    dataSource={data?.studyStatusEntities || []}
                    rowKey="keys"
                    pagination={false}
                />
            </div>
        </div>
    );
}
